export const Header1 = `<div class=" education-details">
<div class="education-school"></div>
<div class="education-date"></div>
<div class="education-location"></div>
        </div> <hr class="experience-hr"/>`;